export default "//static.tradera.net/touchweb/static/output/images/category-consumer-electronics.de55fd81.svg";